import { apiClient } from '@/lib/api/api-client';
import type {
  FreightService,
  FreightServiceProviderPricing,
  FreightPricingType,
} from '../types/import-tracking.types';

const BASE = '/api/freight-services';

export interface CreateFreightServiceDto {
  code: string;
  name: string;
  description?: string | null;
  category?: string | null;
  isActive?: boolean;
  sapCode?: string | null;
  // Precio referencial del catalogo
  referencePrice?: number | null;
  priceCurrency?: string | null;
  pricingType?: 'FLAT' | 'WEIGHT' | 'VOLUME' | null;
}

export interface CreatePricingDto {
  serviceId: string;
  providerId: string;
  pricingType: FreightPricingType;
  unitPrice: number;
  currency?: string;
  minimumCharge?: number | null;
  validFrom?: string | null;
  validUntil?: string | null;
  notes?: string | null;
  isActive?: boolean;
}

export const freightServicesService = {
  // ── Servicios (catálogo) ─────────────────────────────────────────
  list: () => apiClient.get<FreightService[]>(BASE),
  get: (id: string) =>
    apiClient.get<FreightService & { pricings: FreightServiceProviderPricing[] }>(`${BASE}/${id}`),
  create: (dto: CreateFreightServiceDto) => apiClient.post<FreightService>(BASE, dto),
  update: (id: string, dto: Partial<CreateFreightServiceDto>) =>
    apiClient.patch<FreightService>(`${BASE}/${id}`, dto),
  remove: (id: string) => apiClient.delete<{ success: boolean }>(`${BASE}/${id}`),

  // ── Pricings (precio servicio × proveedor) ──────────────────────
  listPricings: (filter?: { providerId?: string; serviceId?: string }) => {
    const qs = new URLSearchParams();
    if (filter?.providerId) qs.set('providerId', filter.providerId);
    if (filter?.serviceId) qs.set('serviceId', filter.serviceId);
    const tail = qs.toString() ? `?${qs.toString()}` : '';
    return apiClient.get<FreightServiceProviderPricing[]>(`${BASE}/pricings/all${tail}`);
  },
  createPricing: (dto: CreatePricingDto) =>
    apiClient.post<FreightServiceProviderPricing>(`${BASE}/pricings`, dto),
  updatePricing: (
    pricingId: string,
    dto: Partial<Omit<CreatePricingDto, 'serviceId' | 'providerId'>>
  ) => apiClient.patch<FreightServiceProviderPricing>(`${BASE}/pricings/${pricingId}`, dto),
  removePricing: (pricingId: string) =>
    apiClient.delete<{ success: boolean }>(`${BASE}/pricings/${pricingId}`),
};
